import { useUser } from './use-user';

export type ProfileType = 'Customer' | 'Logistics';
export type Profile = { id: string; name: string; __typename: ProfileType };

export function useManagingProfile(): Profile | undefined {
  const user = useUser();
  const managingProfile: Profile = user.manageCustomers[0] || user.manageLogistics[0];

  return managingProfile;
}
